import Link from "next/link";
import { ItemsExpansives } from "../../types/ExpansiveItems";
import styles from "./styles.module.scss";

interface ComponentTypes {
  title: string;
  expansor: Array<ItemsExpansives>;
}

export const Expansives = ({ title, expansor }: ComponentTypes) => {
  return (
    <div className={styles.itemsExpansives} style={{ marginTop: 40 }}>
      <details>
        <summary>{title}</summary>
        {expansor.length > 0 &&
          expansor.map((item) => {
            return (
              <Link
                href={item.uri}
                key={item.databaseId}
                passHref
                className={styles.link}
                style={{
                  display: "block",
                  padding: "8px 14px",
                  fontFamily: "Lato",
                }}
              >
                {item.title}
              </Link>
            );
          })}
      </details>
    </div>
  );
};
